/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgIndex = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m20.341 4.247 1.317 1.506L16.41 11H22v2h-5.588l5.247 5.247-1.317 1.506L15 14.412V19h-2V5h2v4.588zM5 11v2H2v-2zm6 0v2H7v-2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgIndex as Index };
